import React, { useEffect, useRef, useState } from 'react';

export const IframeModule = props => {
  const settings = { props };
  const frameRef = useRef(null);
  const [framedHeight, setFramedHeight] = useState('100%');
  const [parsedSource, setParsedSource] = useState(null);

  const callback = () => {
    props.checkHeights();
    if (!frameRef || !frameRef.current) return;
    let l = frameRef.current.contentWindow;
    l.postMessage(
      {
        embedHost: window.location.origin,
        embedPath: window.location.pathname,
        embedSearch: window.location.search,
      },
      '*'
    );
  };

  useEffect(() => {
    callback();
  }, [frameRef.current]);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('append')) {
      const isLocal = window.location.origin.includes('localhost');
      const origin = isLocal ? 'http://localhost:3444' : 'https://venue4you.net';
      const newPath = origin + searchParams.get('append');

      if (newPath !== parsedSource) {
        setParsedSource(searchParams.get('append')?.startsWith('/') ? newPath : origin + '/' + searchParams.get('append'));
      }
    } else {
      if (props.settings.source !== parsedSource) {
        setParsedSource(props.settings.source);
      }
    }

    window.addEventListener('message', function (event) {
      // Check if the message contains the desired height
      const childFrame = frameRef.current.contentWindow;

      if (event.data.origin) {
        childFrame.postMessage(
          {
            origin: window.location.origin,
          },
          '*'
        );
      }

      if (event.data.height) {
        // Set the height of the iframe
        props.moduleRef.current.style.height = event.data.height + 'px';
        setFramedHeight(event.data.height + 'px');
        iframeRef.current.style.height = event.data.height + 'px';
      }
      if (event.data.setScroll) {
        document.querySelector('#body').scrollTop = event.data.setScroll;
      }
      if (event.data.setScrollSmooth) {
        const offset = event.data.setScrollSmooth;
        const target = document.querySelector('#' + settings.props.cssId);
        //target.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
        document.querySelector('#body').scrollTo({
          top: offset,
          behavior: 'smooth',
        });
      }
      if (event.data.revertUrl) {
        var url = window.location.origin + window.location.pathname;
        window.history.pushState({ page_id: 1, user_id: 5 }, '', url);
      }
      if (event.data.reqOverviewScroll) {
        const topOffset = document.querySelector('#body')?.scrollTop ?? 0;
        const searchOffset = document.querySelector('#' + settings.props.cssId)?.getBoundingClientRect()?.top ?? 0;
        childFrame.postMessage(
          {
            overviewScroll: topOffset,
            detailScroll: searchOffset,
          },
          '*'
        );
      }
    });

    setTimeout(() => {
      callback();
    }, 1500);
    setTimeout(() => {
      callback();
    }, 3500);
    setTimeout(() => {
      callback();
    }, 5500);

    const target = document.querySelector('.cms-iframe');

    function handleIntersection(entries) {
      entries.map(entry => {
        if (entry.isIntersecting) {
          callback();
          entry.target.classList.add('visible');
        } else {
          entry.target.classList.remove('visible');
        }
      });
    }
    const observer = new IntersectionObserver(handleIntersection);
    observer.observe(target);
  }, []);

  // useEffect(() => {
  //   var query = window.location.search;
  //   if (query && query.length > 8 && query.substring(0, 8).toLowerCase() == '?append=') {
  //     setParsedSource('https://venue4you.net/' + query.substring(8));
  //   } else {
  //     setParsedSource(props.settings.source);
  //   }

  //   var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  //   var reciever = window[eventMethod];
  //   var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
  //   reciever(messageEvent, e => {
  //     if (e.data) {
  //       if (e.data.height) {
  //         setFramedHeight(e.data.height + 'px');
  //         let l = document.getElementById(props.cssId);
  //         if (l) {
  //           l.style.display = 'block';
  //           l.style.minHeight = e.data.height + 'px';
  //         }
  //         setTimeout(() => {
  //           //let the frame adjust first
  //           props.checkHeights();
  //         }, 500);
  //       }
  //       if (e.data.revertUrl) {
  //         var url = window.location.origin + window.location.pathname;
  //         window.history.pushState({ page_id: 1, user_id: 5 }, '', url);
  //       }
  //       if (e.data.reqOverviewScroll) {
  //         let l = frameRef.current.contentWindow;
  //         let topOffset = document.querySelector('#body')?.scrollTop ?? 0;

  //         let searchOffset = document.querySelector('#' + settings.props.cssId)?.getBoundingClientRect()?.top ?? 0;
  //         l.postMessage(
  //           {
  //             overviewScroll: topOffset,
  //             detailScroll: searchOffset,
  //           },
  //           '*'
  //         );
  //       }
  //       if (e.data.setScroll) {
  //         document.querySelector('#body').scrollTop = e.data.setScroll;
  //       }
  //       if (e.data.setScrollSmooth) {
  //         var offset = e.data.setScrollSmooth;
  //         var target = document.querySelector('#' + settings.props.cssId);
  //         //target.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
  //         document.querySelector('#body').scrollTo({
  //           top: offset,
  //           behavior: 'smooth',
  //         });
  //       }
  //     }
  //   });

  //   //should be waiting for an onload event or something. But since testing is today...
  //   setTimeout(() => {
  //     cb();
  //   }, 1500);
  //   setTimeout(() => {
  //     cb();
  //   }, 3500);
  //   setTimeout(() => {
  //     cb();
  //   }, 5500);

  //   const target = document.querySelector('.cms-iframe');
  //   function handleIntersection(entries) {
  //     entries.map(entry => {
  //       if (entry.isIntersecting) {
  //         cb();
  //         entry.target.classList.add('visible');
  //       } else {
  //         entry.target.classList.remove('visible');
  //       }
  //     });
  //   }
  //   const observer = new IntersectionObserver(handleIntersection);
  //   observer.observe(target);
  // }, []);

  if (settings.hidden || !parsedSource) return null;

  return (
    <div className="w-full">
      <iframe
        ref={frameRef}
        className="cms-iframe"
        src={parsedSource}
        style={{ border: 0, width: '100%', height: framedHeight }}
        allowFullScreen={true}
      ></iframe>
    </div>
  );
};
